import { render, staticRenderFns } from "./PFormRow.vue?vue&type=template&id=9a86c424&"
import script from "./PFormRow.vue?vue&type=script&lang=js&"
export * from "./PFormRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports